export const UPDATE_SEARCH_TERM = 'waitrose/search/UPDATE_SEARCH_TERM';
